import { useQuery } from '@tanstack/react-query';

import { useMetaApiInstance } from '../api';
import { HOST_QUERY_KEY } from '../constants';
import useServiceAppState from './useServiceAppState';

import type { UseQueryOptions } from '@tanstack/react-query';
import type { UserPreference } from '../constants';

type UseUserPreferenceQueryOptions = UseQueryOptions<UserPreference>;

/**
 * 현재 서비스(serviceKeyword)에 대한 사용자 설정(콘솔 버전, 마이그레이션 상태 등)을 제공하는 훅입니다.
 * @description
 * - Meta Api의 fetchUserPreference 응답을 react-query로 제공합니다.
 * - SSR을 지원합니다 (determineUserPreferenceGuard에서 prefetch).
 * - serviceKeyword가 없으면 fetch하지 않습니다.
 */
const useUserPreferenceQuery = (options?: UseUserPreferenceQueryOptions) => {
  const {
    state: { serviceKeyword },
  } = useServiceAppState();
  const { fetchUserPreference } = useMetaApiInstance();

  return useQuery<UserPreference>({
    queryKey: [HOST_QUERY_KEY.GET_USER_PREFERENCE, { serviceKeyword }],
    queryFn: () => fetchUserPreference({ serviceKeyword }),
    enabled: !!serviceKeyword,
    staleTime: Infinity,
    ...options,
  });
};

export default useUserPreferenceQuery;

export type { UseUserPreferenceQueryOptions };
